export const ne = {
    "TRIGGER_LISTEN": "ट्रिगरहरूका लागि सुन्दै,",
    "ASSIST_EMPTY_MSG": "एजेन्ट एआई तपाईँको कुराकानी सक्रिय रूपमा सुन्दैछ र ट्रिगर भएपछि स्वचालित रूपमा सहायता गर्न तयार छ।,",
    "MYBOT_TRIGGET_LISTEN": "वर्तमानमा कुनै सक्रिय मेरो बोट कार्यहरू छैनन्।,",
    "MYBOT_EMTPY_MSG": "मेरो बोटमा कुनै कार्य सुरु गर्न, खोज ट्याबमा जानुहोस् र तपाईंको इच्छित कार्यको लागि \"\"एजेन्ट इनपुटहरूसँग चलाउनुहोस्\"\" विकल्प चयन गर्नुहोस्।,",
    "PROACTIVE_MODE": "प्रोएक्टिभ मोड,",
    "SETTINGS": "सेटिङहरू,",
    "HELP_AND_SUPPORT": "मद्दत र समर्थन,",
    "HELP": "मद्दत,",
    "LANGUAGE": "भाषा,",
    "THEME": "थीम,",
    "AUTOMATIC": "स्वचालित,",
    "DARK": "अँध्यारो,",
    "LIGHT": "उज्यालो,",
    "THEME_DESC": "यसले तपाईंको प्रणालीको पूर्वनिर्धारित मोड प्रयोग गर्नेछ।,",
    "DOCUMENTATION": "डक्युमेन्टेशन,",
    "DOC_DESC": "हाम्रो विस्तृत डक्युमेन्टेशन लेखहरू जाँच गर्नुहोस्।,",
    "FAQ_U": "बारम्बार सोधिने प्रश्नहरू,",
    "FAQ_DESC": "एजेन्ट एआईका बारेमा बारम्बार सोधिने प्रश्नहरू जाँच गर्नुहोस्।,",
    "KORE_ACADEMY": "कोर अकादमी,",
    "KORE_ACA_DESC": "अकादमी पाठ्यक्रमहरू हेरेर एजेन्ट एआईको बारेमा थप जान्नुहोस्।,",
    "SEARCH": "खोजी,",
    "MY_BOT": "मेरो बोट,",
    "ASSIST": "सहायता,",
    "TRANSCRIPT": "प्रतिलिपि,",
    "HISTORY": "इतिहास,",
    "STARTOVER": "फेरि सुरु गर्नुहोस्,",
    "FILE_NAME":"फाइल नाम",
    "AUTO_SCROLL_TOOLTIP": "सहायता ट्याब, मेरो बोट र ट्रान्सक्रिप्ट ट्याब सामग्रीको स्वचालित स्क्रोलिंग नियन्त्रण गर्छ",
    "RESTART_INPUTS": "क्याप्चर गरिएको इनपुटहरूसँग पुनः सुरु गर्नुहोस्,",
    "ASKCUSTOMER": "ग्राहकलाई सोध्नुहोस्,",
    "TELLCUSTOMER": "ग्राहकलाई भन्नुहोस्,",
    "WELCOME_MSG": "स्वागत सन्देश,",
    "SEND": "पठाउनुहोस्,",
    "SENT": "पठाइएको,",
    "TAB_TEXT":"कुनै ट्याब सक्षम छैन! कृपया कम्तीमा एउटा ट्याब सक्षम गर्नुहोस्",
    "AWAITING": "जवाफको प्रतीक्षा गर्दै | जारी राख्न टाइप गर्नुहोस्,",
    "OVERRIDE": "जारी राख्न टाइप गर्नुहोस्,",
    "OVERRIDE_FILE": "जारी राख्न फाइल संलग्न गर्नुहोस्,",
    "ACCEPT_RESPONSE": "जवाफ स्वीकार गरियो,",
    "AGENT_ENTERED": "एजेन्ट प्रवेश गर्यो,",
    "EXPECTED_FORMAT": "अपेक्षित ढाँचा,",
    "INPUT_VALUES": "इनपुट मानहरू,",
    "RESTART": "पुनः सुरु गर्नुहोस्,",
    "START_OVER": "फेरि सुरु गर्नुहोस्,",
    "RESTART_CAPTURE": "क्याप्चर गरिएको इनपुटहरूसँग पुनः सुरु गर्नुहोस्,",
    "CANCEL": "रद्द गर्नुहोस्,",
    "INTERRUPT_DIALOG": "विचलित संवाद कार्य,",
    "TAP_SEARCH":"खोजी गर्न ट्याप गर्नुहोस्",
    "RUN": "चलाउनुहोस्,",
    "RUN_AGENT": "एजेन्टको इनपुटसँग चलाउनुहोस्,",
    "STEP": "चरण,",
    "DIALOG_TASK": "संवाद कार्य,",
    "FAQ": "बारम्बार सोधिने प्रश्नहरू,",
    "SNIPPET": "उत्तरहरू,",
    "ARTICLE": "वेब पृष्ठहरू,",
    "FILE": "फाइलहरू,",
    "SUGGESTED": "सुझाव गरियो,",
    "ALL_DIALOG": "सबै संवाद कार्यहरू,",
    "DIALOG_TEXT": "संवाद,",
    "INTENT_IDENTIFIED": "ग्राहकको उच्चारण,",
    "NOT_WHAT_LOOKING": "गलत सुझाव?",
    "BOT": "बोट,",
    "CUSTOMER": "ग्राहक,",
    "YOU": "तपाईं,",
    "TERMINATE_CONV": "संवाद कार्य समाप्त गर्नुहोस्,",
    "TERMINATE_CONV_DESC": "के तपाईं संवाद कार्य समाप्त गर्न निश्चित हुनुहुन्छ? एजेन्ट एआईले अब सुझाव दिन सक्दैन।,",
    "YES_TERMINATE": "हो समाप्त गर्नुहोस्,",
    "NO_CANCEL": "होइन, रद्द गर्नुहोस्,",
    "OVERRIDE_CONTINUE": "ओभरराइड मोडसँग जारी राख्नुहोस्,",
    "SUMMARY_TEXT": "सारांश,",
    "SUBMIT": "बुझाउनुहोस्,",
    "INTERRUPT_OCCURED": "विचलन भयो,",
    "IDENTIFIED_INTENT": "पहिचान गरिएको उद्देश्य,",
    "INTERRUPT_DESC": "यसलाई चलाउँदा तपाईंको चलिरहेको संवाद कार्य समाप्त हुनेछ।,",
    "ACCEPT_RUN": "स्वीकार गर्नुहोस् र चलाउनुहोस्,",
    "RUN_LATER": "पछि चलाउनुहोस्,",
    "KNOW_MORE": "थप जान्नुहोस्,",
    "MORE_TEXT": "थप,",
    "LESS_TEXT": "कम,",
    "VIEW_MORE": "थप हेर्नुहोस्,",
    "VIEW_LESS": "कम हेर्नुहोस्,",
    "SHOW_MORE_FAQ": "थप बारम्बार सोधिने प्रश्नहरू देखाउनुहोस्,",
    "SHOW_LESS_FAQ": "कम बारम्बार सोधिने प्रश्नहरू देखाउनुहोस्,",
    "SHOW_MORE_ARTICLE": "थप वेब पृष्ठहरू देखाउनुहोस्,",
    "SHOW_LESS_ARTICLE": "कम वेब पृष्ठहरू देखाउनुहोस्,",
    "SHOW_MORE_SNIPPET": "थप उत्तरहरू देखाउनुहोस्,",
    "SHOW_LESS_SNIPPET": "कम उत्तरहरू देखाउनुहोस्,",
    "SHOW_MORE_FILES": "थप फाइलहरू देखाउनुहोस्,",
    "SHOW_LESS_FILES": "कम फाइलहरू देखाउनुहोस्,",
    "VIEW_ALL_DIALOG": "सबै संवादहरू हेर्नुहोस्,",
    "VIEW_FEW_DIALOG": "केही संवादहरू हेर्नुहोस्,",
    "HELP_FULL": "उपयोगी?",
    "THANKYOU": "धन्यवाद!",
    "EXPAND_MORE": "विस्तार गर्नुहोस् / थप,",
    "CLOSE_TEXT": "बन्द गर्नुहोस्,",
    "STARTED": "सुरु भयो,",
    "ENDED": "समाप्त भयो,",
    "VIEW_FULL_ARTICLE": "वेब पृष्ठ हेर्नुहोस्,",
    "VIEW_FULL_FILE": "फाइल हेर्नुहोस्,",
    "COPIED": "प्रतिलिपि गरियो,",
    "SENTI_ANALY": "भाव विश्लेषण,",
    "WRONG_SUGGESTION": "गलत सुझावहरू,",
    "INCORRECT_INTENT": "गलत उद्देश्य,",
    "ACCIDENTAL_CLICK": "गल्तीले क्लिक गरियो,",
    "TIME_TAKING": "समय लाग्ने,",
    "OTHER": "अन्य,",
    "PLAYBOOK_EMPTY_MSG": "प्लेबुक चयन गर्नुहोस्,",
    "PLAYBOOK_EMPTY_DESC": "सबै उपलब्ध प्लेबुकहरू गतिशील भएको कारण एजेन्ट एआईले प्लेबुक लोड गर्न सक्दैन। प्लेबुकमा पहुँच गर्न 'प्लेबुक चयन गर्नुहोस्' क्लिक गर्नुहोस्,",
    "STAGE": "चरण,",
    "PROCEED_TO_CLOSE": "बन्द गर्न अगाडि बढ्नुहोस्,",
    "RECOMENDED_PLAYBOOK": "सिफारिस गरिएको प्लेबुक,",
    "PRIMARY_SCRIPTS": "प्राथमिक स्क्रिप्टहरू,",
    "DYNAMIC_SCRIPTS": "गतिशील स्क्रिप्टहरू,",
    "RESUME": "पुनः सुरु गर्नुहोस्,",
    "ENABLE_CLOSE": "बन्द चरण सक्षम गर्न बन्द गर्न अगाडि बढ्नुहोस् बटनमा क्लिक गर्नुहोस्,",
    "LIST_VIEW": "सूची दृश्य,",
    "TERMINATE": "समाप्त गर्नुहोस्,",
    "MINIMIZE": "न्यूनतम गर्नुहोस्,",
    "MAXIMIZE": "अधिकतम गर्नुहोस्,",
    "NO_SEARCH_RESULT": "कुनै खोज परिणाम फेला परेन,",
    "SENTIMENT_AWAITING": "भाव प्रतीक्षा गर्दै,",
    "POSITIVE": "सकारात्मक,",
    "NEGATIVE": "नकारात्मक,",
    "ASSOCIATED_WORK_NOTES": "विगतको समाधान नोटहरू,",
    "AGENT_JOINED_CONV": "एजेन्ट कुराकानीमा सामेल भयो,",
    "AUTOSCROLL_ASSIST": "स्वतः-स्क्रोल सहायता ट्याब सामग्री,",
    "FILE_SIZE_MSG": "फाइल आकार 25MB भित्र हुनुपर्छ। कृपया पुनः प्रयास गर्नुहोस्।,",
    "OVERRIDE_BTN": "ओभरराइड,",
    "CHOOSE_FILE": "फाइल चयन गर्नुहोस्,",
    "SUMMARY_ERROR_TEXT": "माफ गर्नुहोस्, यो संवादको सारांश सिर्जना गर्दा समस्या भयो। कृपया आफ्नो सारांश सिर्जना गर्नुहोस्,",
    "ASK_A_QUESTION": "प्रश्न सोध्नुहोस्",
    "COPY" : "प्रतिलिपि",
    "PLAYBOOK": "प्लेबुक",
    "TELL_US_MORE": "थप भन्नुस्",
    "THANKS_FEEDBACK": "तपाईंको प्रतिक्रिया को लागि धन्यवाद",
    "SOMETHING_WRONG": "केही न केहि गलत भयो",
    "CLICK_ERROR_DETAILS": "त्रुटिको विवरण हेर्नका लागि क्लिक गर्नुहोस्",
    "NO_ACTIVE_PLAYBOOK": "सक्रिय खेल पुस्तक छैन",
    "REPHRASE_QUESTION": "तपाईंको प्रश्नलाई पुनः शब्द गर्न सक्नुहुन्छ वा अरू केही सोध्न सक्नुहुन्छ?",
    "INTERNAL_INFO": "आन्तरिक जानकारी",
    "SOURCES": "स्रोतहरू",
    "CONVERSATION_SUMMARY": "वार्तालापको संक्षेप",
    "WAITING": "पर्खिरहनु भएको छ",
    "WIDGET_DISABLED": "विजेट निष्क्रिय गरिएको छ",
    "AI_SETTINGS_DISABLED": "एआई सेटिंगहरू निष्क्रिय गरिएको छ! कृपया एआई प्रशासकलाई सम्पर्क गर्नुहोस्",
    "SERVER_CONNECTION_ERROR": "सर्भरसँग जडान गर्दा त्रुटि",
    "VIEW": "हेर्नुहोस्",
    "ATTACHMENT_INPUT": "जोडफाइल इनपुट",
    "TYPE_SUMMARY": "संक्षेपमा टाइप गर्नुहोस्",
    "VIEW_FULL_ARTICLE_2": "पूर्ण लेख हेर्नुहोस्",
    "VIEW_FULL_FILE_2": "पूर्ण फाइल हेर्नुहोस्",
    "BY":"द्वारा",
    GENERATE_SUMMARY: "सारांश सिर्जना गर्नुहोस्",
    PREV_SUMMARIES: "पहिले सिर्जना गरिएका सारांशहरू",
    DIALOG_WORKFLOWS: "संवाद कार्यप्रवाहहरू",
    SHOW_ALL_DIALOG: "सबै संवाद कार्यहरू देखाउनुहोस्",
    SHOW_ALL_DIALOGS: "सबै संवादहरू देखाउनुहोस्",
    CUSTOM_TAB: "अनुकूलन ट्याब",
    AGENT_INPUT: "एजेन्ट इनपुट",
    "CUSTOM_EMPTY_MSG" : "आउटपुट गरिएको छ",
    "CUSTOM_TAB_DESC" : "एजेन्ट इनपुट गर्न अगाडि बढ्नुहोस्।",
    "SUBMIT_OVERALL_FEEDBACK" : "समस्त प्रतिक्रिया पाठवाउनुहोस्",
    "FEEDBACK_POPUP_SUBTITLE" : "विजेट र त्यसको सुविधाहरूका बारेमा तपाईंको अनुभव",
    "FEEDBACK_SATISFIED" : "संतुष्ट",
    "FEEDBACK_UNSATISFIED" : "संतुष्ट छैन",
    "FEEDBACK_PROVIDE_REASONS" : "थप माहिती दिनुहोस्…",
    "FEEDBACK_TITLE" : "प्रतिक्रिया",
    "AGENTIC_THINKING" : "सोच्दै",
    "AGENTIC_AGENT_TITLE" : "एजेन्ट",
    "AGENTIC_COPILOT_MODE_TITLE" : "एजेन्टिक कोपिलट मोड",
    "AGENTIC_SENDING_MESSAGE" : "पठाइरहेको छ...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot तपाईंको कुराकानीलाई सक्रिय रूपमा सुनिरहेको छ र स्वचालित रूपमा सहयोग गर्न तयार छ",
    "AGENTIC_SEARCH_RESULTS" : "एजेन्ट परिणामहरू",
    "PAUSE_AUTO_SEND" : "स्वचालित पठाउने रोक्नुहोस्",
    "PAUSE_AGENTIC" : "एजेन्ट रोक्नुहोस्",
    "RESUME_AGENTIC" : "एजेन्ट पुनः सुरु गर्नुहोस्",
    "RESUME_AUTO_SEND" : "स्वचालित पठाउने पुनः सुरु गर्नुहोस्"
}